var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sendingRecords"},_vm._l((_vm.sendRecordList),function(item,index){return _c('records-item',{ref:item.id,refInFor:true,attrs:{"recordItem":item,"taskRow":_vm.taskRow,"lastRecord":_vm.lastRecord},on:{"closeDetail":_vm.closeDetail,"confirmWithdraw":_vm.confirmWithdraw}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }